import * as React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


type Props = {
    buttonText:string,
    navRoot:string,
}
export const UsedMintBrowserTabMessage: React.FC<Props> = (props) => {
  const nav = useNavigate();
  const [t, i18n] = useTranslation();

  const UsedMintBrowserTabMessageH1 = styled.p`
    font-weight: bold;
    font-size: 17px;
    line-height: 30px;
    color: #FFB16A;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    padding-top: 30px;
    margin-bottom: 15px;
  `;
  const UsedMintBrowserTabMessageA = styled.a`
    padding: 8px 42px;
    gap: 10px;
    width: 300px;
    height: 37px;
    background: #FFB16A;
    border: 1px solid #FFB16A;
    border-radius: 40px;
    color: #FFFBFB;
    text-decoration: none;
    margin-top:50px;
    &:hover {
        opacity: 0.8;
        color: white;
    }
  `;
  return (
    <div id="messege">
        <UsedMintBrowserTabMessageH1>{t(`前回の処理が残っています`)}<br/>{t(`新しいブラウザタブを開いて`)}<br/>{t(`受信ページを読み込んでください`)}</UsedMintBrowserTabMessageH1>
        {/* <UsedMintBrowserTabMessageA onClick={()=>nav(`/${props.navRoot}`)}>{t(props.buttonText)}</UsedMintBrowserTabMessageA> */}
        <UsedMintBrowserTabMessageA href={`${location.href.split(`#`)[0]}`} target ="_blank">{t(props.buttonText)}</UsedMintBrowserTabMessageA>
    </div>
  );
};